import { ReactNode } from 'react';
import { Link } from '@/i18n/navigation';

interface PrefetchLinkProps {
  /** 内部链接(null 表示外部链接或无链接,将渲染为 div) */
  href: string | null;
  /** 点击回调 */
  onClick: (e?: React.MouseEvent) => void;
  /** 子元素 */
  children: ReactNode;
  /** CSS 类名 */
  className?: string;
  /** 是否预加载 */
  prefetch?: boolean;
}

/**
 * 智能链接组件
 * - 内部链接: 使用 Link 组件,支持预加载
 * - 外部链接/无链接: 使用 div 组件,直接触发 onClick
 *
 * 使用说明:
 * - 对于内部链接: onClick 会被调用,然后 Link 会处理导航
 * - 对于外部链接: onClick 负责所有逻辑(包括跳转)
 * - onClick 中应该调用 jumpTo/router.push 来处理导航
 */
export const PrefetchLink = ({
  href,
  onClick,
  children,
  className = '',
  prefetch = true,
}: PrefetchLinkProps) => {
  // 内部链接: 使用 Link
  if (href) {
    return (
      <Link
        href={href}
        prefetch={prefetch}
        className={className}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}
      </Link>
    );
  }

  // 外部链接或无链接: 使用 div
  return (
    <div onClick={onClick} className={`cursor-pointer ${className}`.trim()}>
      {children}
    </div>
  );
};
